import React from "react";

export const steamid = "76561198970865990";